import { createFileRoute, redirect } from '@tanstack/react-router'
import { MainLayout } from '../components/MainLayout'
import { NetWorthPage } from '../pages/NetWorthPage'
import { useAuthStore } from '../stores/auth-store'

export const Route = createFileRoute('/net-worth')({
  component: NetWorth,
  beforeLoad: () => {
    const { isAuthenticated } = useAuthStore.getState()
    if (!isAuthenticated) {
      throw redirect({ to: '/login' })
    }
  },
})

function NetWorth() {
  return (
    <MainLayout>
      <NetWorthPage />
    </MainLayout>
  )
}
